module.exports = __webpack_public_path__ + "static/media/Alton B. Parker - 1904.3d2ad0b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Alton B. Parker - 1904.jpg
// module id = 436
// module chunks = 0